import React from "react";
import { toast } from "react-toastify";
import { useTranslation } from "react-i18next";
import CustomerPageLayout from "../../customer-page-layout/CustomerPageLayout";
import { SwitchButton } from "../../../../common/components/switch-button/SwitchButton";
import { BenefitRow } from "../../../../common/components/benefits-row/BenefitRow";
import { RemoteTokenImg, SpeedDotsIcon, TimeFIlesIcon } from "../../../../assets/icons";
import { useGetEnergyAccountQuery, useUpdatePreferRemoteTokenLoadMutation } from "../../../../service/vending-service";
import styles from "./RemoteTokenPage.module.scss";

export const RemoteTokenPage: React.FC = () => {
	const { t } = useTranslation();
	const { data: energyAccount } = useGetEnergyAccountQuery();
	const [updatePreferRemoteTokenLoad, { isLoading }] = useUpdatePreferRemoteTokenLoadMutation();

	const isActive = energyAccount?.preferRemoteTokenLoad ?? false;

	const handleToggle = async (next: boolean) => {
		try {
			await updatePreferRemoteTokenLoad({ preferRemoteTokenLoad: next }).unwrap();
		} catch {
			toast.error(t("account.web.failedToUpdateRemoteTokenLoad"));
		}
	};

	return (
		<CustomerPageLayout title={t("energyManagement.remoteToken.remoteCommand")} showBackButton={true} decreaseMainContentPadding>
			<div className={styles.image}>
				<RemoteTokenImg />
			</div>

			<div className={styles.card}>
				<div className={styles.toggleRow}>
					<span className={styles.toggleLabel}>{t("common.labels.remoteTokenLoad")}</span>
					<SwitchButton isActive={isActive} onChange={handleToggle} isLoading={isLoading} size="md" activeColor="var(--app-primary)" />
				</div>

				<hr className={styles.divider} />

				<p className={styles.description}>{t("account.web.remoteTokenLoadDescription")}</p>

				<hr className={styles.divider} />

				<div className={styles.benefits}>
					<span className={styles.benefitsTitle}>{t("energyManagement.remoteToken.benefits")}</span>
					<BenefitRow
						badge=""
						title={t("energyManagement.remoteToken.instantTokenAplication")}
						description={t("energyManagement.remoteToken.instantTokenText")}
						leftIcon={<SpeedDotsIcon />}
					/>
					<BenefitRow badge="" title={t("energyManagement.remoteToken.fasterTopUps")} description={t("energyManagement.remoteToken.saveTimeToAvoidErrors")} leftIcon={<TimeFIlesIcon />} />
				</div>
			</div>
		</CustomerPageLayout>
	);
};

export default RemoteTokenPage;
